import React from 'react';
import BerryPulseLayout from './components/Topbar';
import { DataProvider } from './data/DataContext';
function App() {
  return (
    <DataProvider>
      <div style={{
        height: '100%',
        margin: 0,
        overflow: 'hidden', /* Prevent scrolling */
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center', /* Center vertically */
        alignItems: 'center', /* Center horizontally */
        width: '100vw' /* Full viewport width */
      }}>
        <BerryPulseLayout />
      </div>
    </DataProvider>

  );
}

export default App;
